import { getPaxhealthPending, getPaxhealthSuccess, getPaxhealthFail, 
    deletePaxhealthPending, deletePaxhealthSuccess, deletePaxhealthFail,
    getSPaxhealthPending, getSPaxhealthSuccess, getSPaxhealthFail, 
    createPaxhealthPending, createPaxhealthSuccess, createPaxhealthFail, 
    modifyPaxhealthPending, modifyPaxhealthSuccess, modifyPaxhealthFail,reset,imageUploadSuccess,imageUploadFailure } from "./paxhealthSlice";
import { fetchAllPaxhealth, paxhealthDelete, paxhealthCreation, paxhealthModify, fetchSinglePaxhealth } from "../../../api/userApi";

export const getAllPaxhealth = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getPaxhealthPending());
        const result = await fetchAllPaxhealth();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

       // console.log('allPaxhealthData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const paxhealthdetails = JSON.parse(JSON.stringify(myObj.excursionpaxhealths));
        const paxhealthdetails1 = JSON.parse(JSON.stringify(paxhealthdetails));
      // console.log('Paxhealthdetails ' + paxhealthdetails);
       //console.log( paxhealthdetails);
        if (paxhealthdetails) {
        
            return dispatch(getPaxhealthSuccess(paxhealthdetails));
        }
        dispatch(getPaxhealthFail("Paxhealth is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getPaxhealthFail(err.msg));

    }
}

export const paxhealthDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deletePaxhealthPending());
        const result = await paxhealthDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deletePaxhealthSuccess("Paxhealth deleted"))
        : dispatch(deletePaxhealthFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deletePaxhealthFail(err.msg));
    }
    
}

export const newPaxhealthCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createPaxhealthPending());
        const result = await paxhealthCreation(frmDt);
        console.log('myresultpax',result)
        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createPaxhealthSuccess(result.result))
            : dispatch(createPaxhealthFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        // console.log(error);
        //  if(error.response.status===401){}
        const err = JSON.parse(JSON.stringify(error.response.data.error));
       //  console.log(err);
        // console.log('disp');
        // console.log(err.msg);
       
       const row = err.map((er, i) => {
        //console.log('loop');
        //console.log(er.msg);
        //console.log('loop param');

        //console.log(er.param);
            if (i === er.length - 1) {
              return er.param+' '+er.msg+'. ';
            }
            return er.param+' '+er.msg+'\n ';
          });
          //console.log('row');
          //console.log(row);
          dispatch(createPaxhealthFail(row));
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
       
       
       
    }

}

export const getSinglePaxhealth = (id) => async (dispatch) => {
    
 
 console.log('service id : '+id);
    try {
     //call the api
    dispatch(getSPaxhealthPending());
    const result = await fetchSinglePaxhealth(id);
   // const userData=JSON.parse(result.user);
 console.log('PaxhealthData',result);
 //console.log(result);
//  console.log(result.paxhealth);
 
 //console.log('check user profile out if');
    if(result.paxandhealths[0] && result.paxandhealths[0].id){
    //console.log('check user profile');
        return dispatch(getSPaxhealthSuccess(result.paxandhealths[0]));
    }
    dispatch(getSPaxhealthFail("Paxhealth is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSPaxhealthFail(err.msg));
 
 }
    
 
 }




export const paxhealthModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyPaxhealthPending());
        const result = await paxhealthModify(frmDt);
        result.status === "success"
            ? dispatch(modifyPaxhealthSuccess(result.result))
            : dispatch(modifyPaxhealthFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyPaxhealthFail(err.msg));
    }

}


export const resetPaxhealthCreatiion = () => async (dispatch) => {
    try {

        dispatch(reset());
    }
    catch{


    }
}


export const imageuploadProcess = (msg) => async (dispatch) => {
    try {

        dispatch(imageUploadSuccess(msg));
    }
    catch{


    }
}


export const imageUploadFailureProcess = (msg) => async (dispatch) => {
    try {

        dispatch(imageUploadFailure(msg));
    }
    catch{


    }
}
